var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "app-sidebar",
    {
      attrs: {
        id: "widget-wizard-container",
        "show-footer": "",
        "agent-account-details": _vm.AGENT_ACCOUNT_DETAILS,
        logo: _vm.$options.filters.getLogo(),
        title: _vm.$t("sidebar.sections.mortgageApplication"),
        subtitle: _vm.$t("application-standalone.labels.sidebarSubtitle"),
        loading: _vm.loading,
        sidebar: _vm.showSidebar,
        "side-class": "px-0 pb-0",
        "show-agent-license-number": "",
        "client-signup": "",
      },
    },
    [_c("router-view")],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }